import React from 'react';
import WananchiWebsite from './components/Main';
import './App.css';

function App() {
  return (
    <div className="App">
      <WananchiWebsite />
    </div>
  );
}

export default App;